import { render } from "./MessageProcessing.vue?vue&type=template&id=1f1a1622&scoped=true"
import script from "./MessageProcessing.vue?vue&type=script&lang=js"
export * from "./MessageProcessing.vue?vue&type=script&lang=js"

import "./MessageProcessing.vue?vue&type=style&index=0&id=1f1a1622&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1a1622"]])

export default __exports__